import { createStore } from 'vuex'

export const dataPonto = createStore({
  state: () => {
    return {
      type: undefined,
      registeredTime: undefined,
      created_at: null, 
      obs: undefined,
      user: localStorage.getItem('__user_name'),
      user_id: '',

      collabs: [],
    }
  },
  getters: {
    getCollabsCombo: (state) => state.collabs,
  },
  mutations: {
    reset (state) {
      state.obs = undefined
      state.type = undefined
    },
    SET_COLLABS(state, val) {
      state.collabs = val
    }
  },
  actions: {
    setCollabsCombo({ commit }, val) {
      commit('SET_COLLABS', val);
    }
  }
})
